import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-responsive-modal";
import { clientAddNewRequirement, clientDashboard } from "../common/allLinks";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";

export default function ClientRequirementLiveModal() {
  const [values, setValues] = useState({
    open: false,
    isMakeLive: false,
    isBtnClicked: false,
  });

  const navigate = useNavigate();

  const onOpenModal = () => {
    setValues({
      open: true,
    });
  };

  const onCloseModal = () => {
    setValues({
      open: false,
      isMakeLive: values.isMakeLive,
      isBtnClicked: values.isBtnClicked,
    });

    if (values.isMakeLive) {
      navigate({ pathname: clientDashboard });
    }
  };

  const handleOnClickBtnNo = () => {
    setValues({
      ...values,
      isMakeLive: false,
      isBtnClicked: true,
    });
  };

  const handleOnClickBtnYes = () => {
    setValues({
      ...values,
      isMakeLive: true,
      isBtnClicked: true,
    });
  };

  const handleOnClickSaveAndExit = () => {
    onCloseModal();
    navigate({ pathname: clientDashboard });
  };

  const renderText1 = (text1) => {
    return (
      <h2 className="font-24-NunitoSans-600 mb-23 text-center pt-213">
        {text1}
      </h2>
    );
  };

  const renderText2 = (text2) => {
    return (
      <h3 className="font-48-NunitoSans-600 mb-23 text-center">{text2}</h3>
    );
  };

  return (
    <>
      <div className="mobile-text-right">
        <ButtonCommonComponent
          extraClassName="login-btn--req-contact mb-25"
          onClick={onOpenModal}
          text="Make Requirement Live"
        />
      </div>
      <Modal
        open={values.open}
        onClose={onCloseModal}
        closeOnEsc={true}
        closeOnOverlayClick={false}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "customModal customModal--contactDetails",
          closeButton: "customCloseButton",
        }}
      >
        <span className="closeIconInModal" onClick={onCloseModal} />
        <Fragment>
          {!values.isMakeLive && !values.isBtnClicked && (
            <>
              {renderText2("Make it live?")}
              <hr className="mt-common-card__hr" />

              {renderText1(
                "If there are no changes shall we go ahead and make it live on Augment?"
              )}
              <div className="pt-25 text-center">
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border mr-30"
                  text="No, not yet"
                  onClick={handleOnClickBtnNo}
                />
                <ButtonCommonComponent
                  text="Yup, Go Ahead"
                  onClick={handleOnClickBtnYes}
                />
              </div>
            </>
          )}
          {!values.isMakeLive && values.isBtnClicked && (
            <>
              {renderText2("Make it live?")}
              <hr className="mt-common-card__hr" />

              {renderText1("No problem! How would you like to proceed?")}

              <div className="pt-25 text-center">
                {/* <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border mr-30"
                  text="Make Changes"
                  onClick={onCloseModal}
                /> */}
                <LinkBorderCommonButton
                  extraClassName="login-btn-link--preview mr-30"
                  linkText="Make Changes"
                  linkPath={clientAddNewRequirement}
                />
                <ButtonCommonComponent
                  text="Save &amp; Exit"
                  onClick={handleOnClickSaveAndExit}
                />
              </div>
            </>
          )}
          {values.isMakeLive && values.isBtnClicked && (
            <>
              {renderText2("Done!")}
              <hr className="mt-common-card__hr" />

              {renderText1("The post will be live in 24 hours!**")}

              <div className="pt-25 text-center mb-88">
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border mr-30"
                  text="Okay"
                  onClick={onCloseModal}
                />
              </div>

              <p className="font-14-NunitoSans-600">
                **Please note that we will be reviewing the details to weed out
                invalid information and will get in touch incase any discrepancy
              </p>
            </>
          )}
        </Fragment>
      </Modal>
    </>
  );
}
